/**
 * AUTO-GENERATED by scripts/generate-api-client.mjs — do not edit.
 * Regenerate: npm run generate:api
 */

import { apiClient } from '../ApiClient.js';
import { createContractClient } from '../createContractClient.js';
import { filesContract } from '@cnapse/shared/api/contracts.js';

export const filesApi = createContractClient(apiClient, filesContract);
